/* Copyright (c) 2022 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum VisibilityState {
    ON_PAUSE = 'ON_PAUSE',
    ON_RESUME = 'ON_RESUME',
}
